import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import useFetch from "../../../../hooks/useFetch";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";

/**
 * PruebaCrear Component
 * @description: Componente que permite agregar un nuevo prueba.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de pruebas.
 */

const RolesCrear = () => {
  const [show, setShow] = useState(false);
  const { sendRequest, error, setError } = useFetch();

  //Formulario
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nombre: "",
      descripcion: "",
    },
  });

  //Función que hace el POST para crear el prueba.
  const createRol = (data: any) => {
    sendRequest(
      {
        url: `/rol`,
        method: "POST",
        body: data,
      },
      (variable: any) => {
        setShow(true);
        reset({
          nombre: "",
          descripcion: "",
        });
      }
    );
  };

  return (
    <Container>
      <h1>Agregar rol</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Rol agregado"
          body="El rol ha sido agregada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(createRol)}>
        <Row className="mb-4">
          <Form.Group as={Col} md="4" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              {...register("nombre", { required: true, maxLength: 50 })}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 30 caracteres.
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group as={Col} md="8" className="mb-3">
            <Form.Label>Descripcion</Form.Label>
            <Form.Control
              {...register("descripcion", { required: true, maxLength: 50 })}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                La descripcion es obligatoria y no puede ser mayor a 50
                caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{
            backgroundColor: "#21618C",
            borderColor: "white",
          }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default RolesCrear;
